import { FC } from 'react'

import { IconButton } from '@ui/components/Button'
import { WarningIcon } from '@ui/icons/Warning.icon'

interface RiskWarningProps {
  onClick(): void
}
export const ProductRiskWarning: FC<RiskWarningProps> = ({ onClick }) => {
  return (
    <IconButton.Ghost
      icon={{ icon: WarningIcon, color: 'text-warning-high-em' }}
      onClick={onClick}
    />
  )
}
